import { useId } from "react";

export const InfinityGlyph = ({ className = "", strokeWidth = 2.4 }) => {
  const gid = useId().replace(/:/g, "");
  return (
    <svg viewBox="0 0 48 24" className={className} fill="none" aria-hidden="true">
      <defs>
        <linearGradient id={`g${gid}`} x1="0" y1="0" x2="48" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#F3DCB6" />
          <stop offset="0.5" stopColor="#E7C99D" />
          <stop offset="1" stopColor="#B8914F" />
        </linearGradient>
      </defs>
      <path
        d="M24 12C20 6 14 4 10 4A8 8 0 0 0 10 20C14 20 20 18 24 12C28 6 34 4 38 4A8 8 0 0 1 38 20C34 20 28 18 24 12Z"
        stroke={`url(#g${gid})`}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WordmarkLockup = ({ className = "", taglineClass = "text-[10px]", testid = "wordmark-lockup" }) => (
  <div
    data-testid={testid}
    role="img"
    aria-label="Chronoloop — Time keeps us together"
    className={`flex flex-col items-center text-center ${className}`}
  >
    <InfinityGlyph className="relative z-0 h-[0.6em] w-[1.25em] opacity-80" strokeWidth={1.3} />
    <p
      aria-hidden="true"
      className="font-display relative z-10 mt-[0.5em] flex items-center pl-[0.4em] font-normal leading-none tracking-[0.4em] text-[#EEF2F6]"
      style={{ textShadow: "0 1px 16px rgba(3,5,7,0.85)" }}
    >
      <span>CHRONOL</span>
      <InfinityGlyph className="mr-[0.4em] h-[0.66em] w-[1.4em] translate-y-[0.01em]" strokeWidth={2.2} />
      <span>P</span>
    </p>
    <p
      aria-hidden="true"
      className={`relative z-20 mt-[1.1em] whitespace-nowrap pl-[0.38em] font-normal tracking-[0.38em] text-[#DCE3EA] ${taglineClass}`}
      style={{ textShadow: "0 0 6px rgba(3,5,7,0.95), 0 1px 14px rgba(3,5,7,0.9)" }}
    >
      TIME KEEPS US TOGETHER
    </p>
  </div>
);

export const Wordmark = ({ className = "", testid = "wordmark" }) => (
  <span
    data-testid={testid}
    aria-label="Chronoloop"
    role="img"
    className={`font-display inline-flex items-center font-medium tracking-[0.24em] text-[#E6EDF4] ${className}`}
  >
    <span aria-hidden="true">CHRONOL</span>
    <InfinityGlyph className="mr-[0.24em] h-[0.72em] w-[1.5em] translate-y-[0.02em]" />
    <span aria-hidden="true">P</span>
  </span>
);
